<template>
  <saffron-link
    :to="{ name: 'store-categories-cid-deals', params: { cid: category.id } }"
    v-if="category"
    class="flex category-intro flex-column flex-center flex-middle c-text plain-link"
    style="min-height: 150px; flex: 100%">
    <div
      class="media-block background-cover"
      :style="{
                'background-image':
                  'url(' + category.introImage + ')',
              }"></div>
    <div class="content-block">
      <h4 class="text-l category-intro-title margin-remove">
        {{category.name}}
      </h4>
      <div class="category-intro-separator"></div>
      <div class="category-intro-text text-s">
        <content-blocks :content="category.intro"></content-blocks>
      </div>
      <span class="deal-count">
        {{translate('justopp.categoryIntro.dealCount', {count: category?.productCount ? category?.productCount : 0})}}
      </span>
    </div>
  </saffron-link>
</template>

<script>
export default {
  props: {
    category: {
      type: Object,
      default: false,
    }
  },
  data: function () {
    return {};
  },
  created() {

  }
};
</script>

<style scoped lang="scss">
.category-intro {
  text-align: center;
  background-color: var(--c-gray-1);
  border: 1px solid var(--c-gray-2);
  border-radius: var(--border-radius-s);
  box-shadow: var(--box-shadow-2);
  max-width: 400px;
  overflow: hidden;

  .media-block {
    order: 1;
    height: 175px;
    flex: 175px;
    width: 100%;

    box-shadow: 0 0 5px 1px rgba(0, 0, 0, 0.2);

    @media (max-width: 1024px) {
      height: 250px;
      flex: 250px;
    }
  }

  .content-block {
    order: 2;
    padding: var(--margin-xl) var(--margin-m);
    border-top: 1px solid var(--c-gray-3);

    .category-intro-title {
      font-weight: 600;
    }

    .category-intro-separator {
      height: 2px;
      width: 150px;
      margin: var(--margin-l) auto;
      background-color: var(--c-gray-2);
    }

    .deal-count {
      display: block;
      margin-top: var(--margin-2xl);
      opacity: 0.8;
      font-weight: bold;
      font-size: var(--font-s);
    }
  }

  &:nth-child(2n) {
    .media-block {
      order: 2;
      border-top: 1px solid var(--c-gray-3);
    }

    .content-block {
      border-top: none;
      order: 1;
    }
  }
}
</style>
